import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';

import { StorageKeyEnum } from '@app/core/enums/storage-key.enum';
import { ToolsHelper } from '@app/core/helpers/tools.helper';
import { IMapSliderModel, UserModel } from '@app/core/models';
import { APP_CONFIG, IAppConfig, StorageService } from '@app/core/services';

enum ActiveMenuItemEnum {
  DEALS = 1,
  TICKETS,
  AUTH,
}

@Component({
  selector: 'app-user-block',
  templateUrl: './user-block.component.html',
  styleUrls: ['./user-block.component.scss'],
})
export class UserBlockComponent implements OnInit {
  @Input() public boxBtnMode = false;

  public readonly ActiveMenuItemEnum = ActiveMenuItemEnum;

  public activedMenuItem: ActiveMenuItemEnum | null;
  public recommended: Array<IMapSliderModel> = [];

  get user(): UserModel {
    return this.storageService.USER;
  }

  constructor(
    @Inject(APP_CONFIG) public readonly appConfig: IAppConfig,
    @Inject(DOCUMENT) private document: Document,
    private storageService: StorageService,
  ) {}

  ngOnInit(): void {
    this.recommended = this.storageService.DESTINATION_ON_SLIDER;
  }

  getSlideImage(slideItem): any {
    if (slideItem.image) {
      return {
        'background-image': ToolsHelper.initBackground(slideItem.image),
      };
    }

    return null;
  }

  toggleMenuHandler(val: boolean | void, item: ActiveMenuItemEnum): void {
    console.log(val, item);
    if (val == null) {
      this.activedMenuItem = item === this.activedMenuItem ? null : item;
    } else if (val === true) {
      this.activedMenuItem = item;
    } else {
      this.activedMenuItem = null;
    }
  }

  logout(): void {
    this.storageService.removeKey(StorageKeyEnum.USER);
    this.storageService.removeKey(StorageKeyEnum.TOKEN);
    this.storageService.removeKey(StorageKeyEnum.PLANS);
    this.storageService.removeKey(StorageKeyEnum.PROFILE);
    this.document.location.reload();
  }
}
